import React from "react";

const SearchUsers = () => {
  return (
    <div>
      <svg
        className="animated"
        id="freepik_stories-location-tracking"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <style
          dangerouslySetInnerHTML={{
            __html:
              "svg#freepik_stories-location-tracking:not(.animated) .animable {opacity: 0;}svg#freepik_stories-location-tracking.animated #freepik--background-simple--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-location-tracking.animated #freepik--Shadow--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-location-tracking.animated #freepik--Plant--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-location-tracking.animated #freepik--Device--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-location-tracking.animated #freepik--location-3--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-location-tracking.animated #freepik--location-2--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-location-tracking.animated #freepik--location-1--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-location-tracking.animated #freepik--Briefcase--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-location-tracking.animated #freepik--Character--inject-3 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}            @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ",
          }}
        />
        <g
          id="freepik--background-simple--inject-3"
          style={{ transformOrigin: "245.172062px 236.439865px" }}
          className="animable"
        >
          <path
            d="M78.08,127.67c27.53-44.07,99.17-53.18,136.15-12.44s34.73,83.41,52.18,96.05,57.86-48.37,102.26-43.71S446.26,193.3,432,258.49s-92.15,136-194.85,123.89S.64,251.63,78.08,127.67Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "245.172062px 236.439865px",
            }}
            id="eld90nvae3lsg"
            className="animable"
          />
          <g id="el4mswi1gqv9">
            <path
              d="M78.08,127.67c27.53-44.07,99.17-53.18,136.15-12.44s34.73,83.41,52.18,96.05,57.86-48.37,102.26-43.71S446.26,193.3,432,258.49s-92.15,136-194.85,123.89S.64,251.63,78.08,127.67Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.9",
                transformOrigin: "245.172062px 236.439865px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--Shadow--inject-3"
          style={{ transformOrigin: "250px 416.239983px" }}
          className="animable"
        >
          <ellipse
            id="freepik--path--inject-3"
            cx={250}
            cy="416.24"
            rx="193.89"
            ry="11.32"
            style={{
              fill: "rgb(245, 245, 245)",
              transformOrigin: "250px 416.24px",
            }}
            className="animable"
          />
        </g>
        <g
          id="freepik--Plant--inject-3"
          style={{ transformOrigin: "92.833439px 372.636032px" }}
          className="animable"
        >
          <path
            d="M94.68,389.08l-1,0c0-1.31,1.1-32.32,6.5-37.58,5.58-5.43,12.14-.08,12.2,0l-.64.77c-.24-.2-5.93-4.82-10.86,0C95.76,357.15,94.69,388.76,94.68,389.08Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "103.029999px 369.074371px",
            }}
            id="elrs26ncjsgn"
            className="animable"
          />
          <path
            d="M94.24,395.3l-1-.1c0-.37,3.48-37.6-10-53.07l.76-.65C97.76,357.27,94.39,393.75,94.24,395.3Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "88.974941px 368.389984px",
            }}
            id="elsj2k7aktgaj"
            className="animable"
          />
          <path
            d="M94.55,391.32c-.11-1.76-2.71-43.19,7.68-52.75l.68.74c-10,9.23-7.39,51.52-7.36,51.94Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "98.546329px 364.945007px",
            }}
            id="elqgpu6q80iek"
            className="animable"
          />
          <path
            d="M93.24,391.29c0-.28-.32-28.07-7.67-32.28a4.59,4.59,0,0,0-4.24-.44c-4.31,1.78-6.6,10-6.62,10.09l-1-.26c.1-.36,2.45-8.79,7.2-10.75a5.6,5.6,0,0,1,5.13.49c7.84,4.49,8.16,32,8.17,33.14Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "83.959995px 374.267212px",
            }}
            id="elf2d5b4mq32"
            className="animable"
          />
          <path
            d="M96.27,391.31c0-.89-1.19-22,4.8-29.83,1.6-2.09,3.39-3.07,5.32-2.94,4.28.3,7.59,6.08,7.73,6.33l-.87.49c0-.06-3.19-5.56-6.93-5.82-1.57-.11-3.07.75-4.45,2.55-5.77,7.53-4.61,29-4.6,29.17Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "105.146889px 374.919296px",
            }}
            id="elk00d16tvvm"
            className="animable"
          />
          <path
            d="M95.2,394.23l-1-.07c0-.51,3.76-50.74-2.42-59.1l.8-.6C99,343.12,95.36,392.15,95.2,394.23Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "94.075806px 364.345001px",
            }}
            id="eliu8fbfixtjl"
            className="animable"
          />
          <path
            d="M79.24,362.7s3.83,1.41,2.69,4.74-13.24,8.82-13.24,8.82-5.07-4.65-.42-12.21S79.14,360.32,79.24,362.7Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "74.224415px 367.926178px",
            }}
            id="el39l83jdv4vg"
            className="animable"
          />
          <g id="elogpkyreda6">
            <path
              d="M79.24,362.7s3.83,1.41,2.69,4.74-13.24,8.82-13.24,8.82-5.07-4.65-.42-12.21S79.14,360.32,79.24,362.7Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "74.224415px 367.926178px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M95.89,356.36s-4.08-.17-4.31,3.34,8.83,13.24,8.83,13.24,6.47-2.34,5.08-11.11S96.9,354.19,95.89,356.36Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "98.630703px 363.8806px",
            }}
            id="elmrzxrbm6kta"
            className="animable"
          />
          <g id="elx59tamrgr2">
            <path
              d="M95.89,356.36s-4.08-.17-4.31,3.34,8.83,13.24,8.83,13.24,6.47-2.34,5.08-11.11S96.9,354.19,95.89,356.36Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "98.630703px 363.8806px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M99.34,339.53s-2.72-.29-2.5-1.94,10.57-5.92,16.68,1c0,0-3.91,6.72-9.56,6.8S99.34,339.53,99.34,339.53Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "105.173668px 340.079941px",
            }}
            id="el6dsd14vyq9r"
            className="animable"
          />
          <g id="elz7zbn0oq23e">
            <path
              d="M99.34,339.53s-2.72-.29-2.5-1.94,10.57-5.92,16.68,1c0,0-3.91,6.72-9.56,6.8S99.34,339.53,99.34,339.53Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "105.173668px 340.079941px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M94.28,335.51s2.46,1.19,3.15-.33-5.84-10.61-14.67-8c0,0-.23,7.77,4.52,10.83S94.28,335.51,94.28,335.51Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "90.11911px 332.820679px",
            }}
            id="elssbipta83w"
            className="animable"
          />
          <g id="elkm07etc0mb">
            <path
              d="M94.28,335.51s2.46,1.19,3.15-.33-5.84-10.61-14.67-8c0,0-.23,7.77,4.52,10.83S94.28,335.51,94.28,335.51Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "90.11911px 332.820679px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M107.15,361.36s-1.88-1.51.15-2.25,12-.53,12.06,9.31c0,0-11.57,1.92-13-1.83S107.15,361.36,107.15,361.36Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "112.619946px 363.880402px",
            }}
            id="eljfrtl2jzduh"
            className="animable"
          />
          <g id="el7u8a04in603">
            <path
              d="M107.15,361.36s-1.88-1.51.15-2.25,12-.53,12.06,9.31c0,0-11.57,1.92-13-1.83S107.15,361.36,107.15,361.36Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "112.619946px 363.880402px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M83.55,339.29s1.88-1.52-.15-2.26-12-.53-12.06,9.32c0,0,11.57,1.92,13-1.83S83.55,339.29,83.55,339.29Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "78.080059px 341.805481px",
            }}
            id="el7vm274nrzlc"
            className="animable"
          />
          <g id="elgqvpmjnszw7">
            <path
              d="M83.55,339.29s1.88-1.52-.15-2.26-12-.53-12.06,9.32c0,0,11.57,1.92,13-1.83S83.55,339.29,83.55,339.29Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "78.080059px 341.805481px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M89.67,347.22s.16-1.85-1.32-1.12-6.67,6.31-1.3,11.61c0,0,7.23-5.36,5.93-8.14S89.67,347.22,89.67,347.22Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "88.903496px 351.819733px",
            }}
            id="el172thvsa6xq"
            className="animable"
          />
          <g id="elojmp5l1ao2o">
            <path
              d="M89.67,347.22s.16-1.85-1.32-1.12-6.67,6.31-1.3,11.61c0,0,7.23-5.36,5.93-8.14S89.67,347.22,89.67,347.22Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "88.903496px 351.819733px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M108.83,349.84s-1.13-1.47.52-1.65,9,1.78,7.29,9.13c0,0-9-.68-9.36-3.73S108.83,349.84,108.83,349.84Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "112.065498px 352.749435px",
            }}
            id="el6egeqwvydeu"
            className="animable"
          />
          <g id="elcphloilz3gd">
            <path
              d="M108.83,349.84s-1.13-1.47.52-1.65,9,1.78,7.29,9.13c0,0-9-.68-9.36-3.73S108.83,349.84,108.83,349.84Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "112.065498px 352.749435px",
              }}
              className="animable"
            />
          </g>
          <polygon
            points="78.53 418.56 109.3 418.56 112.62 384.88 75.21 384.88 78.53 418.56"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "93.915001px 401.720001px",
            }}
            id="eltdbed801zmm"
            className="animable"
          />
          <g id="elmrwd5z1g0rn">
            <rect
              x="73.57"
              y="381.16"
              width="40.69"
              height="7.43"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "93.915px 384.875px",
                transform: "rotate(180deg)",
              }}
              className="animable"
            />
          </g>
          <g id="elh6vkeqg7zrj">
            <rect
              x="73.57"
              y="381.16"
              width="40.69"
              height="7.43"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "93.915px 384.875px",
                transform: "rotate(180deg)",
              }}
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--Device--inject-3"
          style={{ transformOrigin: "232.024986px 234.135468px" }}
          className="animable"
        >
          <path
            d="M173.59,143.9H147l-.23-2.69a.63.63,0,0,1,.63-.69h25.26a.77.77,0,0,1,.75.69Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "160.178574px 142.209991px",
            }}
            id="elocpxkugwyn"
            className="animable"
          />
          <path
            d="M143.59,143.9H117l-.23-2.69a.63.63,0,0,1,.63-.69h25.26a.77.77,0,0,1,.75.69Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "130.178558px 142.209991px",
            }}
            id="elrdz3dbsn50b"
            className="animable"
          />
          <path
            d="M355.57,141.9H92.77a6,6,0,0,0-6.08,6.53L101.3,321.22a7.3,7.3,0,0,0,7.18,6.53h262.8a6,6,0,0,0,6.08-6.53L362.75,148.43A7.29,7.29,0,0,0,355.57,141.9Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "232.024986px 234.824997px",
            }}
            id="elumihe59o1em"
            className="animable"
          />
          <g id="elqsy8cn0tp4e">
            <path
              d="M371.28,327.75H112.48a7.3,7.3,0,0,1-7.18-6.53L90.69,148.43a6,6,0,0,1,6.08-6.53h258.8a7.29,7.29,0,0,1,7.18,6.53l14.61,172.79A6,6,0,0,1,371.28,327.75Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                transformOrigin: "234.024986px 234.82502px",
              }}
              className="animable"
            />
          </g>
          <polygon
            points="358.75 322.38 115.91 322.38 101.11 147.26 343.95 147.26 358.75 322.38"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "229.930008px 234.82px",
            }}
            id="elun0heqhczkq"
            className="animable"
          />
          <g id="ele3v3mw8ru3k">
            <g
              style={{
                opacity: "0.5",
                transformOrigin: "102.740486px 234.82486px",
              }}
              className="animable"
            >
              <g id="el0zzj3tlyayi">
                <path
                  d="M104.52,231.38a2,2,0,0,0-1.93-1.75,1.6,1.6,0,0,0-1.63,1.75,2,2,0,0,0,1.93,1.76A1.6,1.6,0,0,0,104.52,231.38Z"
                  style={{
                    opacity: "0.6",
                    isolation: "isolate",
                    transformOrigin: "102.740486px 231.385017px",
                  }}
                  className="animable"
                />
              </g>
              <g id="ela9ucowvyq3t">
                <path
                  d="M103.32,238.26a.8.8,0,0,0-.81.88,1,1,0,0,0,1,.88.81.81,0,0,0,.82-.88A1,1,0,0,0,103.32,238.26Z"
                  style={{
                    opacity: "0.6",
                    isolation: "isolate",
                    transformOrigin: "103.41951px 239.139992px",
                  }}
                  className="animable"
                />
              </g>
            </g>
          </g>
          <g id="els4a2zummyto">
            <path
              d="M365.78,234.82a4.91,4.91,0,0,1-5,5.38,6,6,0,0,1-5.91-5.38,4.9,4.9,0,0,1,5-5.37A6,6,0,0,1,365.78,234.82Z"
              style={{
                opacity: "0.5",
                isolation: "isolate",
                transformOrigin: "360.324951px 234.824875px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M90.71,170.82H89a.77.77,0,0,1-.75-.68L87,155.74a.63.63,0,0,1,.64-.68h1.71a.77.77,0,0,1,.75.68l1.22,14.4A.62.62,0,0,1,90.71,170.82Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "89.160469px 162.939957px",
            }}
            id="el3qf4qzl6gv3"
            className="animable"
          />
          <g id="elo306yyejyz">
            <path
              d="M90.71,170.82H89a.77.77,0,0,1-.75-.68L87,155.74a.63.63,0,0,1,.64-.68h1.71a.77.77,0,0,1,.75.68l1.22,14.4A.62.62,0,0,1,90.71,170.82Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                transformOrigin: "89.160469px 162.939957px",
              }}
              className="animable"
            />
          </g>
          <g id="elwl8w9sbswuc">
            <polygon
              points="358.75 322.38 115.91 322.38 101.11 147.26 343.95 147.26 358.75 322.38"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.7",
                isolation: "isolate",
                transformOrigin: "229.930008px 234.82px",
              }}
              className="animable"
            />
          </g>
          <g id="elpylbnaxtoq">
            <polygon
              points="263.53 189.49 268.08 243.3 352.07 243.3 353.84 264.25 303.04 264.25 307.96 322.38 298.46 322.38 293.54 264.25 222.33 264.25 227.25 322.38 205.97 322.38 201.05 264.25 149.94 264.25 152.72 297.16 143.59 301.45 115.26 314.75 114.39 304.46 142.72 291.16 140.44 264.25 110.99 264.25 109.22 243.3 199.28 243.3 195.89 203.12 101.5 151.93 101.11 147.27 111.88 147.27 194.97 192.33 191.17 147.27 212.45 147.27 220.56 243.3 258.58 243.3 250.47 147.27 259.97 147.27 262.74 180.13 346.73 180.13 347.52 189.49 263.53 189.49"
              style={{
                opacity: "0.1",
                isolation: "isolate",
                transformOrigin: "227.474998px 234.825005px",
              }}
              className="animable"
            />
          </g>
          <g id="elhwehnhgj99m">
            <polygon
              points="159.74 238.26 194.29 238.26 192.37 215.55 157.82 215.55 159.74 238.26"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "176.055px 226.904999px",
              }}
              className="animable"
            />
          </g>
          <g id="el3gthxbe7426">
            <polygon
              points="155.54 223.66 140.71 223.66 141.94 238.26 156.78 238.26 155.54 223.66"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "148.745003px 230.959999px",
              }}
              className="animable"
            />
          </g>
          <g id="el0yhh895360oj">
            <polygon
              points="124.14 238.26 138.97 238.26 137.74 223.66 122.91 223.66 124.14 238.26"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "130.940002px 230.959999px",
              }}
              className="animable"
            />
          </g>
          <g id="elbak2d9upwge">
            <polygon
              points="130.93 173.22 113.66 163.94 109.88 171.54 127.14 180.83 130.93 173.22"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "120.404995px 172.385002px",
              }}
              className="animable"
            />
          </g>
          <g id="elw5ucgopmxq">
            <polygon
              points="146.54 191.26 150.32 183.66 133.06 174.37 129.27 181.97 146.54 191.26"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "139.795006px 182.814995px",
              }}
              className="animable"
            />
          </g>
          <g id="el4fvh7865lbp">
            <polygon
              points="165.93 201.7 169.71 194.09 152.45 184.81 148.67 192.41 165.93 201.7"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "159.190002px 193.254997px",
              }}
              className="animable"
            />
          </g>
          <g id="elyspeflycias">
            <path
              d="M123.1,190.24h-4.75a6.17,6.17,0,0,0-6.3,6.77l1.15,13.63a7.57,7.57,0,0,0,7.45,6.76h4.74a6.18,6.18,0,0,0,6.31-6.76L130.54,197A7.56,7.56,0,0,0,123.1,190.24Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "121.874008px 203.819969px",
              }}
              className="animable"
            />
          </g>
          <g id="elmph994eqeoa">
            <polygon
              points="250.92 215.55 223.23 215.55 225.03 236.84 252.72 236.84 250.92 215.55"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "237.974998px 226.195px",
              }}
              className="animable"
            />
          </g>
          <g id="elzzfefrulua">
            <polygon
              points="232.83 207.37 250.23 207.37 248.78 190.24 231.38 190.24 232.83 207.37"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "240.805px 198.805px",
              }}
              className="animable"
            />
          </g>
          <g id="elz0epipugef">
            <polygon
              points="237.42 165.94 219.04 165.94 220.57 184.04 238.95 184.04 237.42 165.94"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "228.994995px 174.989998px",
              }}
              className="animable"
            />
          </g>
          <g id="elxz83mks8bi">
            <polygon
              points="284.39 156.89 266.01 156.89 267.54 174.99 285.93 174.99 284.39 156.89"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "275.970001px 165.940002px",
              }}
              className="animable"
            />
          </g>
          <g id="eldtjjmwlkacc">
            <polygon
              points="272.77 236.84 296.24 236.84 295.4 226.91 271.93 226.91 272.77 236.84"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "284.084991px 231.875px",
              }}
              className="animable"
            />
          </g>
          <g id="elq1tlyjigt6">
            <polygon
              points="299.93 236.84 323.4 236.84 322.56 226.91 299.09 226.91 299.93 236.84"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "311.244995px 231.875px",
              }}
              className="animable"
            />
          </g>
          <g id="el5ez2sbetw3r">
            <polygon
              points="327.1 236.84 344.24 236.84 343.4 226.91 326.26 226.91 327.1 236.84"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "335.25px 231.875px",
              }}
              className="animable"
            />
          </g>
          <g id="elez401616oer">
            <path
              d="M267.71,283.05a15.63,15.63,0,0,0-16,17.14,19.15,19.15,0,0,0,18.85,17.13,15.62,15.62,0,0,0,16-17.13A19.15,19.15,0,0,0,267.71,283.05Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "269.135056px 300.18515px",
              }}
              className="animable"
            />
          </g>
          <g id="elmfceqre8skr">
            <ellipse
              cx="327.97"
              cy="210.14"
              rx="10.94"
              ry="11.92"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "327.97px 210.14px",
                transform: "rotate(-51.52deg)",
              }}
              className="animable"
            />
          </g>
          <g id="el6n1mece4jd">
            <polygon
              points="249.16 269.64 227.8 269.64 228.94 283.05 250.3 283.05 249.16 269.64"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "239.050003px 276.345001px",
              }}
              className="animable"
            />
          </g>
          <g id="elxpuqj30670g">
            <polygon
              points="313.44 303.04 325.57 303.04 322.75 269.64 310.62 269.64 313.44 303.04"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "318.095001px 286.340012px",
              }}
              className="animable"
            />
          </g>
          <g id="elrx9t1st5cfp">
            <polygon
              points="328.81 269.64 329.95 283.05 351.36 283.05 350.23 269.64 328.81 269.64"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "340.084991px 276.345001px",
              }}
              className="animable"
            />
          </g>
          <g id="el1uqm65g51sa">
            <polygon
              points="122.65 283.05 136.28 283.05 135.15 269.64 121.52 269.64 122.65 283.05"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "128.899998px 276.345001px",
              }}
              className="animable"
            />
          </g>
          <g id="elhh8qd38j5ub">
            <polygon
              points="161.05 288.76 183 288.76 181.51 271.11 159.55 271.11 161.05 288.76"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "171.275002px 279.934998px",
              }}
              className="animable"
            />
          </g>
          <g id="el515tqrok4gs">
            <polygon
              points="159.5 317.44 199.67 317.44 198.63 305.12 158.46 305.12 159.5 317.44"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "179.065002px 311.279999px",
              }}
              className="animable"
            />
          </g>
          <g id="elr1wewxllufc">
            <polygon
              points="163.9 165.69 185.84 177.25 184.17 157.5 163.2 157.5 163.9 165.69"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.4",
                isolation: "isolate",
                transformOrigin: "174.519997px 167.375px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M204.36,151.39A8.93,8.93,0,0,0,191.73,164l6.31,6.31,6.32-6.31A8.93,8.93,0,0,0,204.36,151.39Zm-3.86,8.77a3.48,3.48,0,1,1,0-4.92A3.47,3.47,0,0,1,200.5,160.16Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "198.159111px 159.656258px",
            }}
            id="elfuor4083ojo"
            className="animable"
          />
          <g id="elai446g25k7">
            <path
              d="M204.36,164,198,170.33v-9.15a3.48,3.48,0,0,0,0-7v-5.45A8.94,8.94,0,0,1,204.36,164Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                transformOrigin: "202.493668px 159.529945px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M321.84,212.25a8.93,8.93,0,0,0-12.63,12.63l6.31,6.31,6.32-6.31A8.93,8.93,0,0,0,321.84,212.25ZM318,221a3.48,3.48,0,1,1,0-4.92A3.47,3.47,0,0,1,318,221Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "315.525146px 220.412117px",
            }}
            id="elzzx0jz5nuan"
            className="animable"
          />
          <g id="elhg2h8hjo6ai">
            <path
              d="M321.84,224.88l-6.32,6.31V222a3.48,3.48,0,0,0,0-7v-5.45a8.94,8.94,0,0,1,6.32,15.25Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                transformOrigin: "319.983612px 220.370003px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M201.54,294.5a8.93,8.93,0,0,0-12.63,12.63l6.31,6.31,6.32-6.31A8.93,8.93,0,0,0,201.54,294.5Zm-3.86,8.77a3.48,3.48,0,1,1,0-4.92A3.47,3.47,0,0,1,197.68,303.27Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "195.229507px 302.666473px",
            }}
            id="el3p5t9qs6fj7"
            className="animable"
          />
          <g id="elabt0gixialq">
            <path
              d="M201.54,307.13l-6.32,6.31v-9.15a3.48,3.48,0,0,0,0-7v-5.45a8.94,8.94,0,0,1,6.32,15.25Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                transformOrigin: "199.683609px 302.639999px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--location-3--inject-3"
          style={{ transformOrigin: "281.379997px 182.829895px" }}
          className="animable"
        >
          <g id="elowep9icv55">
            <path
              d="M331.94,156H227.76a5.6,5.6,0,0,0-5.59,5.6v37.66a5.59,5.59,0,0,0,5.59,5.59h76.15L314,212.66l-3-7.84h21a5.59,5.59,0,0,0,5.59-5.59V161.57A5.6,5.6,0,0,0,331.94,156Z"
              style={{
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "279.879997px 184.329895px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M334.94,153H230.76a5.6,5.6,0,0,0-5.59,5.6v37.66a5.59,5.59,0,0,0,5.59,5.59h76.15L314,212.66V201.82h21a5.59,5.59,0,0,0,5.59-5.59V158.57A5.6,5.6,0,0,0,334.94,153Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "282.879997px 182.829895px",
            }}
            id="el2sot7rt2y9i"
            className="animable"
          />
          <g id="ely9wm7zqzyo">
            <path
              d="M266.61,163.55v27.7a2.73,2.73,0,0,1-.29,1.24.36.36,0,0,1,0,.09,2.49,2.49,0,0,1-.19.3,2.83,2.83,0,0,1-1,.87,2.79,2.79,0,0,1-.95.31,1.27,1.27,0,0,1-.28,0h-28a2.52,2.52,0,0,1-.56-.09h0l-.08,0a3,3,0,0,1-.58-.26,2.25,2.25,0,0,1-.36-.24,2.66,2.66,0,0,1-.6-.65,2.74,2.74,0,0,1-.46-1.38,1.21,1.21,0,0,1,0-.19v-27.7a2.84,2.84,0,0,1,2.75-2.84h27.78A2.84,2.84,0,0,1,266.61,163.55Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.7",
                transformOrigin: "249.933105px 177.38887px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M326.18,172.56H279.06a1.24,1.24,0,0,1-1.24-1.24h0a1.24,1.24,0,0,1,1.24-1.23h47.12a1.23,1.23,0,0,1,1.23,1.23h0A1.23,1.23,0,0,1,326.18,172.56Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "302.615036px 171.324989px",
            }}
            id="elo9nbdy20qrk"
            className="animable"
          />
          <path
            d="M311.05,160.71H279.58a1.76,1.76,0,1,0,0,3.51h31.47a1.76,1.76,0,0,0,0-3.51Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "295.182404px 162.465019px",
            }}
            id="elb4msonkmrew"
            className="animable"
          />
          <path
            d="M307.18,177.64H279.06a1.25,1.25,0,0,1-1.24-1.24h0a1.25,1.25,0,0,1,1.24-1.24h28.12a1.24,1.24,0,0,1,1.23,1.24h0A1.24,1.24,0,0,1,307.18,177.64Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "293.115021px 176.400002px",
            }}
            id="elqysw1w296h"
            className="animable"
          />
          <path
            d="M245.1,161.31a13.07,13.07,0,0,1,12.27-2.71c7.11,2.21,4,15.44,4,15.44a9.75,9.75,0,0,1,1.79,10c-2.22,5.87-19.2,7.17-24.95,2.1s.94-17.8,4.23-19.28S245.1,161.31,245.1,161.31Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "249.890594px 173.683319px",
            }}
            id="elr3nrqsitgvs"
            className="animable"
          />
          <path
            d="M265.11,193.75a2.79,2.79,0,0,1-.95.31,1.27,1.27,0,0,1-.28,0h-28a2.52,2.52,0,0,1-.56-.09h0l-.08,0a3,3,0,0,1-.58-.26,2.25,2.25,0,0,1-.36-.24,2.66,2.66,0,0,1-.6-.65c-.09-.44-.18-.9-.28-1.36,2-.34,3.92-.61,5.9-.79,1.46-.14,2.93-.23,4.41-.28.71,0,1.43,0,2.14-.06,2.42,0,4.85,0,7.26.24l1.55.14c2.27.28,4.67.72,6.55,1.1s3.44.74,3.44.74S264.94,192.65,265.11,193.75Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "249.264977px 192.198875px",
            }}
            id="elmxcu076l2i"
            className="animable"
          />
          <g id="elw4r8tjz10j">
            <path
              d="M265.11,193.75a2.79,2.79,0,0,1-.95.31,1.27,1.27,0,0,1-.28,0h-28a2.52,2.52,0,0,1-.56-.09h0l-.08,0a3,3,0,0,1-.58-.26,2.25,2.25,0,0,1-.36-.24,2.66,2.66,0,0,1-.6-.65c-.09-.44-.18-.9-.28-1.36,2-.34,3.92-.61,5.9-.79,1.46-.14,2.93-.23,4.41-.28.71,0,1.43,0,2.14-.06,2.42,0,4.85,0,7.26.24l1.55.14c2.27.28,4.67.72,6.55,1.1s3.44.74,3.44.74S264.94,192.65,265.11,193.75Z"
              style={{
                opacity: "0.3",
                isolation: "isolate",
                transformOrigin: "249.264977px 192.198875px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M254,194.09h-6.18a7.81,7.81,0,0,1-3-2.66,5.5,5.5,0,0,0,1.15-1.1,5.4,5.4,0,0,0,.74-1.2,9.93,9.93,0,0,0,.41-5.91h0c-.15-.75-.32-1.27-.35-1.38v0l7,2.29c-.14.47-.25.91-.35,1.32-.15.61-.25,1.16-.33,1.65a9.51,9.51,0,0,0-.11,2,4,4,0,0,0,.31,1.46c.42,1,1.12,1.13,1.12,1.13A2.52,2.52,0,0,1,254,194.09Z"
            style={{
              fill: "rgb(228, 137, 123)",
              transformOrigin: "249.685036px 187.964996px",
            }}
            id="el6k1r105bzxm"
            className="animable"
          />
          <g id="el2e46pxrx992">
            <path
              d="M253.62,184.1a23.44,23.44,0,0,0-.68,3c-3.33-1.26-6.27-5.26-6.27-5.26Z"
              style={{
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "250.144997px 184.470009px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M249.92,163.5c6.23-.62,8.58,2.52,9.67,8.9,1.37,8,.16,13.86-7.81,12.92C241,184,239.56,164.53,249.92,163.5Z"
            style={{
              fill: "rgb(228, 137, 123)",
              transformOrigin: "251.474815px 174.421043px",
            }}
            id="elz437q3sfb1h"
            className="animable"
          />
          <path
            d="M255.52,172.45a13.11,13.11,0,0,0,2.08,2.41,1.73,1.73,0,0,1-1.58.87Z"
            style={{
              fill: "rgb(222, 87, 83)",
              transformOrigin: "256.560005px 174.090874px",
            }}
            id="el9qe4m86cj5u"
            className="animable"
          />
          <path
            d="M251.65,172.32c.07.51-.16,1-.5,1s-.67-.34-.73-.85.16-1,.5-1S251.59,171.81,251.65,172.32Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "251.036346px 172.395004px",
            }}
            id="el2l90gii35ex"
            className="animable"
          />
          <path
            d="M250.78,171.51l1.06-.57S251.4,171.94,250.78,171.51Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "251.309998px 171.278687px",
            }}
            id="elziq52qrlbjb"
            className="animable"
          />
          <path
            d="M258,171.43c.06.51-.16,1-.51,1s-.66-.33-.73-.85.17-1,.51-1S257.93,170.92,258,171.43Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "257.37883px 171.50499px",
            }}
            id="elezxgrjx6tk"
            className="animable"
          />
          <path
            d="M257.13,170.63l1.06-.58S257.75,171.06,257.13,170.63Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "257.660004px 170.393295px",
            }}
            id="elobfm7encta"
            className="animable"
          />
          <path
            d="M248.55,169.59a.36.36,0,0,1-.2-.06.37.37,0,0,1-.1-.5,3.59,3.59,0,0,1,2.92-1.37.37.37,0,0,1,.36.37.4.4,0,0,1-.38.35,2.93,2.93,0,0,0-2.3,1.05A.34.34,0,0,1,248.55,169.59Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "249.861465px 168.624428px",
            }}
            id="elxt1iv0ious"
            className="animable"
          />
          <path
            d="M258.21,167.93a.33.33,0,0,1-.17,0,2.56,2.56,0,0,0-2.21-.26.36.36,0,0,1-.32-.65,3.26,3.26,0,0,1,2.87.27.36.36,0,0,1,.15.49A.37.37,0,0,1,258.21,167.93Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "256.940399px 167.37368px",
            }}
            id="ely6qz0q9xz9"
            className="animable"
          />
          <path
            d="M255.36,178.27a15.74,15.74,0,0,0-.52,2.24c-.13,0-.27,0-.4,0-1.84,0-2.69-.61-3.07-1.28a2.34,2.34,0,0,1-.29-1.08,2.31,2.31,0,0,1,0-.64,8.69,8.69,0,0,0,3.6.75C255.11,178.28,255.36,178.27,255.36,178.27Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "253.208862px 179.01001px",
            }}
            id="eln8c9fahi3db"
            className="animable"
          />
          <path
            d="M254.73,178.26l-.17.66c-1.72,0-2.94-.25-3.48-.77a2.31,2.31,0,0,1,0-.64A8.69,8.69,0,0,0,254.73,178.26Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "252.89386px 178.214996px",
            }}
            id="elp5k68dzz1e"
            className="animable"
          />
          <path
            d="M254.44,180.51c-1.84,0-2.69-.61-3.07-1.28a6.07,6.07,0,0,1,2,.41A2.19,2.19,0,0,1,254.44,180.51Z"
            style={{
              fill: "rgb(222, 87, 83)",
              transformOrigin: "252.904999px 179.869995px",
            }}
            id="elfayu8yixln"
            className="animable"
          />
          <path
            d="M244.14,174.69s2.41-5.42,1.58-9.33c0,0,11.86-6.28,13.71,6.21,0,0,.1-11.26-10.64-10.45s-9.15,16.51-3.14,20.63C245.65,181.75,242.66,178.07,244.14,174.69Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "250.177605px 171.414169px",
            }}
            id="elvf2a26vxgia"
            className="animable"
          />
          <path
            d="M245.29,175.9a2.74,2.74,0,0,0-3.19-2.2c-1.91.4-2.44,4.46,2.46,4.94C245.27,178.7,245.59,178,245.29,175.9Z"
            style={{
              fill: "rgb(228, 137, 123)",
              transformOrigin: "243.062889px 176.148972px",
            }}
            id="el0vcn6m3e222"
            className="animable"
          />
          <path
            d="M265.11,193.75a2.79,2.79,0,0,1-.95.31,1.27,1.27,0,0,1-.28,0h-28a2.52,2.52,0,0,1-.56-.09h0l-.08,0a3,3,0,0,1-.58-.26,2.25,2.25,0,0,1-.36-.24,2.66,2.66,0,0,1-.6-.65c-.09-.44-.18-.9-.28-1.36,2-.34,3.92-.61,5.9-.79,1.46-.14,2.93-.23,4.41-.28.71,0,1.43,0,2.14-.06,2.42,0,4.85,0,7.26.24l1.55.14c2.27.28,4.67.72,6.55,1.1s3.44.74,3.44.74S264.94,192.65,265.11,193.75Z"
            style={{
              fill: "rgb(228, 137, 123)",
              transformOrigin: "249.264977px 192.198875px",
            }}
            id="elpdx55wcfdct"
            className="animable"
          />
          <path
            d="M240.87,194.09h-5a2.52,2.52,0,0,1-.56-.09h0l-.08,0a3,3,0,0,1-.58-.26,2.25,2.25,0,0,1-.36-.24,2.66,2.66,0,0,1-.6-.65,2.74,2.74,0,0,1-.46-1.38l5.56-1.73s.2.34.52,1S240.28,192.62,240.87,194.09Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "237.049995px 191.915001px",
            }}
            id="elw8trni83gf"
            className="animable"
          />
          <path
            d="M266.32,192.49a.36.36,0,0,1,0,.09,2.49,2.49,0,0,1-.19.3,2.83,2.83,0,0,1-1,.87,2.79,2.79,0,0,1-.95.31,1.27,1.27,0,0,1-.28,0h-4.53c-.17-1.57-.34-3.58-.34-3.58Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "262.676422px 192.273857px",
            }}
            id="elexlr2ztpiuf"
            className="animable"
          />
          <path
            d="M249.92,163.5s1.21,7.91-6.07,10.44c-8.79,3.06-9.22,12.18-1.34,14.4,0,0-8-1.9-8.87-7.42s4.71-13.06,4.71-13.06-1.87-4.81,5.26-7.44C247.63,158.94,249.92,163.5,249.92,163.5Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "241.771614px 174.232231px",
            }}
            id="elkcsjfxg5ja8"
            className="animable"
          />
          <path
            d="M249,170.92a.27.27,0,0,1-.12,0,.26.26,0,0,1-.1-.34c2.95-5.28.45-7.78.34-7.89a.25.25,0,0,1,0-.35.26.26,0,0,1,.36,0c.12.12,2.9,2.85-.25,8.49A.26.26,0,0,1,249,170.92Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "249.739845px 166.597183px",
            }}
            id="elfaekkv1sdd7"
            className="animable"
          />
          <path
            d="M262.06,186.73a.25.25,0,0,1-.18-.08.24.24,0,0,1,0-.35,7.32,7.32,0,0,0,2.5-5.56c-.13-3.92-3.75-7.07-3.78-7.1a.24.24,0,0,1,0-.35.25.25,0,0,1,.35,0c.16.14,3.82,3.32,4,7.46a7.82,7.82,0,0,1-2.65,5.94A.23.23,0,0,1,262.06,186.73Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "262.73732px 179.982964px",
            }}
            id="elqduoclxhwo"
            className="animable"
          />
        </g>
        <g
          id="freepik--location-2--inject-3"
          style={{ transformOrigin: "187.145016px 117.404999px" }}
          className="animable"
        >
          <g id="elgdfpjbl77w">
            <path
              d="M237.75,86.55H133.57a5.6,5.6,0,0,0-5.59,5.6v37.66a5.6,5.6,0,0,0,5.59,5.6h52.82L195,151.26l-1.73-15.85h44.44a5.6,5.6,0,0,0,5.6-5.6V92.15A5.6,5.6,0,0,0,237.75,86.55Z"
              style={{
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "185.645016px 118.904999px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M240.75,83.55H136.57a5.6,5.6,0,0,0-5.59,5.6v37.66a5.6,5.6,0,0,0,5.59,5.6h52.82L195,151.26l1.27-18.85h44.44a5.6,5.6,0,0,0,5.6-5.6V89.15A5.6,5.6,0,0,0,240.75,83.55Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "188.645012px 117.404999px",
            }}
            id="elcgsuj65p5ab"
            className="animable"
          />
          <g id="elfdto6sgrryn">
            <path
              d="M172.43,94.13v27.7a.37.37,0,0,1,0,.11,2.8,2.8,0,0,1-.32,1.22,2.49,2.49,0,0,1-.19.3,2.81,2.81,0,0,1-1.44,1.07,2.68,2.68,0,0,1-.49.11,1.27,1.27,0,0,1-.28,0h-28a2.52,2.52,0,0,1-.56-.09h0l-.08,0a3,3,0,0,1-.58-.26,2.25,2.25,0,0,1-.36-.24,2.73,2.73,0,0,1-.48-.48,2,2,0,0,1-.24-.39,2.69,2.69,0,0,1-.35-1.35V94.13a2.84,2.84,0,0,1,2.75-2.84h27.78A2.84,2.84,0,0,1,172.43,94.13Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.7",
                transformOrigin: "155.746986px 107.968868px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M232,103.14H184.87a1.24,1.24,0,0,1-1.24-1.23h0a1.24,1.24,0,0,1,1.24-1.24H232a1.24,1.24,0,0,1,1.24,1.24h0A1.24,1.24,0,0,1,232,103.14Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "208.434998px 101.905003px",
            }}
            id="elo2spnjefxj"
            className="animable"
          />
          <path
            d="M216.86,91.29H185.39a1.76,1.76,0,1,0,0,3.51h31.47a1.76,1.76,0,1,0,0-3.51Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "201.125008px 93.044998px",
            }}
            id="el0blpy67mrxuk"
            className="animable"
          />
          <path
            d="M213,108.22H184.87a1.25,1.25,0,0,1-1.24-1.24h0a1.25,1.25,0,0,1,1.24-1.24H213a1.25,1.25,0,0,1,1.24,1.24h0A1.25,1.25,0,0,1,213,108.22Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "198.935005px 106.980003px",
            }}
            id="elhtm2asz3cm7"
            className="animable"
          />
          <path
            d="M167,124.67h-19.2a6.58,6.58,0,0,1,0-1.4c0-.14,0-.27,0-.39a2.72,2.72,0,0,1,.07-.33,3.35,3.35,0,0,1,1.65-2.44c.38-.09.84-.18,1.36-.28h0l.9-.15h0l.91-.14a37.42,37.42,0,0,1,5.89-.4,18.76,18.76,0,0,1,1.88.12,4.68,4.68,0,0,1,.54.08,6.84,6.84,0,0,1,2.85,1h0a7.33,7.33,0,0,1,1.62,1.66,11.81,11.81,0,0,1,.72,1.11A12.55,12.55,0,0,1,167,124.67Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "157.381332px 121.903839px",
            }}
            id="elewbpfyrt8q"
            className="animable"
          />
          <path
            d="M172.42,121.94a2.8,2.8,0,0,1-.32,1.22,2.49,2.49,0,0,1-.19.3,2.81,2.81,0,0,1-1.44,1.07,2.68,2.68,0,0,1-.49.11,1.27,1.27,0,0,1-.28,0h-28a2.52,2.52,0,0,1-.56-.09h0l-.08,0a3,3,0,0,1-.58-.26,2.25,2.25,0,0,1-.36-.24,2.73,2.73,0,0,1-.48-.48c1.25-.12,3-.28,5.12-.45h0l2-.16.73-.06.32,0,2.11-.15c.15,0,.31,0,.48,0h0c2-.15,4.24-.28,6.53-.4h0l3.66-.16,2.57-.09.77,0,.76,0,.81,0h.31l1.2,0C168.86,121.93,170.65,121.92,172.42,121.94Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "156.029991px 123.290138px",
            }}
            id="elw4oz6fjb1ms"
            className="animable"
          />
          <g id="elvst51zdkvn">
            <path
              d="M172.42,121.94a2.8,2.8,0,0,1-.32,1.22,2.49,2.49,0,0,1-.19.3,2.81,2.81,0,0,1-1.44,1.07,2.68,2.68,0,0,1-.49.11,1.27,1.27,0,0,1-.28,0h-28a2.52,2.52,0,0,1-.56-.09h0l-.08,0a3,3,0,0,1-.58-.26,2.25,2.25,0,0,1-.36-.24,2.73,2.73,0,0,1-.48-.48c1.25-.12,3-.28,5.12-.45h0l2-.16.73-.06.32,0,2.11-.15c.15,0,.31,0,.48,0h0c2-.15,4.24-.28,6.53-.4h0l3.66-.16,2.57-.09.77,0,.76,0,.81,0h.31l1.2,0C168.86,121.93,170.65,121.92,172.42,121.94Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                isolation: "isolate",
                transformOrigin: "156.029991px 123.290138px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M162.58,124.67h-7.72l-.34-.07a9,9,0,0,1-4.07-1.9h0l-.24-.23a6.47,6.47,0,0,0,1.64-2.79h0c.06-.2.13-.41.18-.62a18.39,18.39,0,0,0,.55-4.2,0,0,0,0,0,0,0,1.93,1.93,0,0,0,0-.24,36.15,36.15,0,0,0-.12-3.76c-.1-1.11-.22-2.17-.37-3.15-.09-.6-.18-1.17-.28-1.69l.87.76.08.06,3.46,3,1,.86,3.52,3.06a15.8,15.8,0,0,0-.35,1.63l0,.15a8.86,8.86,0,0,0-.06,2.76,4,4,0,0,0,.09.48,4,4,0,0,0,.15.49.49.49,0,0,0,0,.11,4.55,4.55,0,0,0,.77,1.3,5.44,5.44,0,0,0,1.88,1.38,8.75,8.75,0,0,0,1.62.56l0,0C165.35,123.55,163.88,124.25,162.58,124.67Z"
            style={{
              fill: "rgb(228, 137, 123)",
              transformOrigin: "157.576836px 115.344994px",
            }}
            id="el5ojprggsa7e"
            className="animable"
          />
          <g id="el7t4x3jxs6nk">
            <path
              d="M153.65,110.62c-.08,5.71,4.47,7.65,6.73,8.15a8.19,8.19,0,0,1,0-3.24Z"
              style={{
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "157.014473px 114.695004px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M165.47,124.67H149.81l-2-1.4-.38-.27.11-.1.39-.35,1.64-1.48,1.37-1.24h0l.95-.86.14.09.73.48L157,122.3h0l2.85,1.87.81-2,.6-1.52.09,0L164,122l.27.14a2.12,2.12,0,0,1,.58.44l0,0a2.08,2.08,0,0,1,.41.63,1.34,1.34,0,0,1,.07.18A2.63,2.63,0,0,1,165.47,124.67Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "156.46257px 121.820004px",
            }}
            id="elwu9bw6gku4j"
            className="animable"
          />
          <path
            d="M166.31,92.69c2.84,1.65,3.47,8.58-.45,13.13s-7.84-12-7.84-12S164.5,91.64,166.31,92.69Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "163.320229px 99.507835px",
            }}
            id="elnnzfof3r73"
            className="animable"
          />
          <path
            d="M153.82,116.16a8.33,8.33,0,0,0,10,.93,9.26,9.26,0,0,0,4.14-5.41c.09-.31.16-.63.23-1,1-6-.49-15.69-7.09-17.9a9,9,0,0,0-11.82,9.78C150.12,109.14,150.28,113,153.82,116.16Z"
            style={{
              fill: "rgb(228, 137, 123)",
              transformOrigin: "158.831772px 105.317081px",
            }}
            id="el090qccwrczpc"
            className="animable"
          />
          <path
            d="M159.4,103.81c0,.53.34,1,.69.92s.6-.47.57-1-.35-.94-.69-.92S159.37,103.27,159.4,103.81Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "160.030037px 103.774109px",
            }}
            id="elvf3chncodfr"
            className="animable"
          />
          <path
            d="M165.44,103.42c0,.54.35,1,.7.93s.6-.48.57-1-.35-1-.7-.93S165.41,102.92,165.44,103.42Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "166.075005px 103.38512px",
            }}
            id="el5girrjwdk2x"
            className="animable"
          />
          <path
            d="M163.54,103.81a19,19,0,0,0,2.84,4.41,3.1,3.1,0,0,1-2.54.64Z"
            style={{
              fill: "rgb(222, 87, 83)",
              transformOrigin: "164.959991px 106.362717px",
            }}
            id="elv7o0h2be0os"
            className="animable"
          />
          <path
            d="M167.51,100.7a.31.31,0,0,1-.32,0,2.56,2.56,0,0,0-2.27-.12.31.31,0,1,1-.3-.54h0a3.14,3.14,0,0,1,2.86.12.31.31,0,0,1,.14.42h0A.57.57,0,0,1,167.51,100.7Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "166.045471px 100.248425px",
            }}
            id="el7f2rw8f2iml"
            className="animable"
          />
          <path
            d="M158.05,101.47a.35.35,0,0,1-.18,0,.31.31,0,0,1,0-.44h0a3.14,3.14,0,0,1,2.73-.89.32.32,0,0,1,.24.38h0a.32.32,0,0,1-.38.23h0a2.57,2.57,0,0,0-2.15.74A.3.3,0,0,1,158.05,101.47Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "159.312943px 100.805305px",
            }}
            id="elh4j2mx41ru"
            className="animable"
          />
          <path
            d="M153.61,94.11l.22,1c-.88.61-.89,3.62-.32,4.71,1.2,2.32.24,6.23-1.45,7.94,0,0-.17-1-1-.69s0,5.79,2,8.2c0,0-2.88-2.07-5-7.64-2-5.16-2.63-9.56-1.76-11.74Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "149.982101px 104.689999px",
            }}
            id="eloam8g9zvk39"
            className="animable"
          />
          <path
            d="M146.79,108.18a6.25,6.25,0,0,0,3.78,2.93c2.12.56,3.16-1.35,2.55-3.34-.56-1.76-2.32-4.24-4.45-3.9A2.79,2.79,0,0,0,146.79,108.18Z"
            style={{
              fill: "rgb(228, 137, 123)",
              transformOrigin: "149.804878px 107.523727px",
            }}
            id="el0iqohxqunm17"
            className="animable"
          />
          <path
            d="M163.54,110.58a16.92,16.92,0,0,0-.69,2.41l-.44,0c-2-.11-2.88-.82-3.26-1.57a2.71,2.71,0,0,1-.25-1.19,2.33,2.33,0,0,1,.1-.69,9.38,9.38,0,0,0,3.86,1A6.38,6.38,0,0,0,163.54,110.58Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "161.219742px 111.265003px",
            }}
            id="elcvcmxnxg3ag"
            className="animable"
          />
          <path
            d="M162.86,110.53l-.22.71c-1.88-.11-3.18-.44-3.74-1a2.33,2.33,0,0,1,.1-.69A9.38,9.38,0,0,0,162.86,110.53Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "160.879982px 110.394997px",
            }}
            id="elto9b50z6fz8"
            className="animable"
          />
          <path
            d="M162.41,113c-2-.11-2.88-.82-3.26-1.57a6.44,6.44,0,0,1,2.19.56A2.4,2.4,0,0,1,162.41,113Z"
            style={{
              fill: "rgb(222, 87, 83)",
              transformOrigin: "160.780006px 112.215px",
            }}
            id="elaz59hkojb4l"
            className="animable"
          />
          <path
            d="M165.83,110.89a2.93,2.93,0,0,0-3.52-1,4.09,4.09,0,0,0-2.53-1.37,4.89,4.89,0,0,0-3.55,1.32,4.12,4.12,0,0,0-.33.4,4.8,4.8,0,0,0-.67,1.55,7.66,7.66,0,0,0,.11,4s0,0,0,0a5.08,5.08,0,0,0,1.06,2,4.32,4.32,0,0,0,1.59,1.14c.22.09.43.16.65.23a5.78,5.78,0,0,0,1.92.23c.17,0,.33,0,.5,0a5.66,5.66,0,0,0,4.28-2.84,7.75,7.75,0,0,0,.44-1C166.46,113.73,166.54,111.67,165.83,110.89Zm-8.62-.2a2,2,0,0,1,1.41-1.41,3.53,3.53,0,0,1,3.51,1s2.81-1.12,3.19,1.92-1.68,4.51-2.89,3.74-.18-2.15-.18-2.15l-1.32-.37a2.73,2.73,0,0,1-.55,1.92l-.09.11a1.44,1.44,0,0,1-2.16.12,4.05,4.05,0,0,1-1.11-2.52A5.16,5.16,0,0,1,157.21,110.69Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "160.671822px 113.956329px",
            }}
            id="el9xof6c2rgw4"
            className="animable"
          />
          <path
            d="M152.28,95.88a7.47,7.47,0,0,1,7-.81c3.63,1.26,4.68,1.64,5.89-1.07s-.93-8.92-5.87-9.11-7.95,6.24-7.95,6.24-7.77,2.86-5.1,10.09Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "155.596298px 93.052933px",
            }}
            id="elg99cup3bq78"
            className="animable"
          />
          <path
            d="M139.65,123.57a2,2,0,0,1-.24-.39L146,121.9l.32-.06.53,1.12c.22.45.49,1,.83,1.71h-5.91a2.52,2.52,0,0,1-.56-.09h0l-.08,0a3,3,0,0,1-.58-.26,2.25,2.25,0,0,1-.36-.24A2.73,2.73,0,0,1,139.65,123.57Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "143.544998px 123.255005px",
            }}
            id="elwqatfkvpze"
            className="animable"
          />
          <path
            d="M172.43,121.43v.4a.37.37,0,0,1,0,.11,2.8,2.8,0,0,1-.32,1.22,2.49,2.49,0,0,1-.19.3,2.81,2.81,0,0,1-1.44,1.07,2.68,2.68,0,0,1-.49.11,1.27,1.27,0,0,1-.28,0h-2.9c-.19-.59-.36-1.12-.52-1.57s-.29-.82-.41-1.12c-.2-.53-.33-.84-.36-.91h0Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "168.977043px 122.843872px",
            }}
            id="elme3tj691q3"
            className="animable"
          />
          <path
            d="M150.61,124.67h-6.84a9.87,9.87,0,0,1,1-1.55h0A8.56,8.56,0,0,1,146,121.9a7.71,7.71,0,0,1,3.62-1.79,2.71,2.71,0,0,0,0,1,12.12,12.12,0,0,0,.4,1.66C150.12,123.31,150.34,124,150.61,124.67Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "147.190002px 122.390007px",
            }}
            id="el014vzex7d9tn"
            className="animable"
          />
          <path
            d="M170.47,124.53a2.68,2.68,0,0,1-.49.11,1.27,1.27,0,0,1-.28,0h-3.93c-.14-.42-.28-.83-.43-1.23a1.34,1.34,0,0,0-.07-.18c-.16-.43-.33-.84-.52-1.25a17.67,17.67,0,0,0-.83-1.69h0a16.92,16.92,0,0,1,1.56.73h0c.45.23,1,.52,1.56.89A24.89,24.89,0,0,1,170.47,124.53Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "167.195px 122.468864px",
            }}
            id="el92omu6u2zxl"
            className="animable"
          />
        </g>
        <g
          id="freepik--location-1--inject-3"
          style={{ transformOrigin: "159.340004px 266.159966px" }}
          className="animable"
        >
          <g id="el4w046tpixn4">
            <path
              d="M209.91,239.32H105.74a5.6,5.6,0,0,0-5.6,5.59v37.67a5.6,5.6,0,0,0,5.6,5.59h76.14l10.06,5.92-3-5.92h21a5.6,5.6,0,0,0,5.6-5.59V244.91A5.6,5.6,0,0,0,209.91,239.32Z"
              style={{
                opacity: "0.2",
                isolation: "isolate",
                transformOrigin: "157.840004px 266.704994px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M212.91,236.32H108.74a5.6,5.6,0,0,0-5.6,5.59v37.67a5.6,5.6,0,0,0,5.6,5.59h76.14L191.94,296V285.17h21a5.6,5.6,0,0,0,5.6-5.59V241.91A5.6,5.6,0,0,0,212.91,236.32Z"
            style={{
              fill: "rgb(61, 80, 250)",
              transformOrigin: "160.840004px 266.159966px",
            }}
            id="el30gff183rvp"
            className="animable"
          />
          <g id="elcgy98ngdcee">
            <path
              d="M144.58,246.9v27.7a2.85,2.85,0,0,1-.33,1.33,2.49,2.49,0,0,1-.19.3,2.82,2.82,0,0,1-1.93,1.18,1.27,1.27,0,0,1-.28,0h-28a2.52,2.52,0,0,1-.56-.09h0l-.08,0a3,3,0,0,1-.58-.26,2.25,2.25,0,0,1-.36-.24,2.81,2.81,0,0,1-1.07-2.22V246.9a2.84,2.84,0,0,1,2.75-2.84h27.78A2.84,2.84,0,0,1,144.58,246.9Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.7",
                transformOrigin: "127.889988px 260.738823px",
              }}
              className="animable"
            />
          </g>
          <g
            id="freepik--group--inject-3"
            style={{ transformOrigin: "128.024998px 260.125267px" }}
            className="animable"
          >
            <path
              d="M142.13,277.41a1.27,1.27,0,0,1-.28,0h-1.42l0-.42h.09a5.33,5.33,0,0,1,1.63.38Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "141.290001px 277.203873px",
              }}
              id="elz6zznrx6hme"
              className="animable"
            />
            <g id="elckgfck94faj">
              <path
                d="M142.13,277.41a1.27,1.27,0,0,1-.28,0h-1.42l0-.42h.09a5.33,5.33,0,0,1,1.63.38Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.4",
                  isolation: "isolate",
                  transformOrigin: "141.290001px 277.203873px",
                }}
                className="animable"
              />
            </g>
            <path
              d="M141.84,277.43H131l0,0s0,0,0,0H117.14l.07.14a1,1,0,0,1-.08-.14H113.9c.93-.15,1.95-.3,3-.42l.67-.08c.89-.11,1.8-.2,2.7-.27l.25,0c1.62-.13,3.23-.23,4.85-.3h.37c.77,0,1.53-.06,2.29-.07,1.13,0,2.26,0,3.39,0h.65c.83,0,1.67,0,2.5.05l.93.08c.27,0,.53.05.8.06.74.08,1.46.17,2.15.27l1,.15.49.08.46.07.08,0a5.34,5.34,0,0,1,1.24.36Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "127.869999px 276.930008px",
              }}
              id="el4i674m649wi"
              className="animable"
            />
            <path
              d="M135.83,277.44H131l0,0s0,0,0,0h-9.5a9.15,9.15,0,0,1-1-.8l-.44-.41a6.21,6.21,0,0,0,1.57-2c1.2-2.36,1-5.29.69-7.38h0c-.13-1-.29-1.76-.33-2.23v0a1,1,0,0,1,0-.16c0-.15,0-.25.06-.28l.19.07.47.17.23.08,7.94,2.85c-.06.26-.11.52-.16.78s-.1.53-.13.79l-.06.49a9.55,9.55,0,0,0-.06,1.06,7,7,0,0,0,.25,2,4.5,4.5,0,0,0,.94,1.78h0a3.11,3.11,0,0,0,.44.45,7.13,7.13,0,0,0,3.24,1.47,2.29,2.29,0,0,1,.14.27A3.43,3.43,0,0,1,135.83,277.44Z"
              style={{
                fill: "rgb(235, 179, 118)",
                transformOrigin: "127.945px 270.809998px",
              }}
              id="elxks7xgnd0oe"
              className="animable"
            />
            <g id="el68m05xe1upc">
              <path
                d="M130.74,272.4c-3-.62-6.42-2.7-7.32-5.26a10.88,10.88,0,0,1-.69-2.75l8.17,2.93A10.48,10.48,0,0,0,130.74,272.4Z"
                style={{
                  opacity: "0.2",
                  isolation: "isolate",
                  transformOrigin: "126.815002px 268.394989px",
                }}
                className="animable"
              />
            </g>
            <path
              d="M120.88,254.67c.55,6.42.56,10.21,3.91,13.41,5,4.84,12.88,1.69,14.27-4.78,1.24-5.82.11-15.35-6.26-17.75a8.81,8.81,0,0,0-11.38,5A9,9,0,0,0,120.88,254.67Z"
              style={{
                fill: "rgb(235, 179, 118)",
                transformOrigin: "130.168606px 257.69207px",
              }}
              id="el5x3s2fyd7j"
              className="animable"
            />
            <path
              d="M130.7,256.22c0,.52.29.93.64.93s.61-.45.6-1-.31-.94-.65-.93S130.69,255.68,130.7,256.22Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "131.32px 256.184906px",
              }}
              id="el9hk9ufb5tim"
              className="animable"
            />
            <path
              d="M136.62,256.06c0,.52.3.94.64.93s.61-.44.6-1-.3-.94-.64-.93S136.61,255.57,136.62,256.06Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "137.239998px 256.024971px",
              }}
              id="elsilh0fqdjd"
              className="animable"
            />
            <path
              d="M134.74,256.37a19,19,0,0,0,2.62,4.42,3,3,0,0,1-2.5.53Z"
              style={{
                fill: "rgb(213, 135, 69)",
                transformOrigin: "136.050003px 258.884888px",
              }}
              id="elmm3w257e4"
              className="animable"
            />
            <path
              d="M128.81,254.34a.3.3,0,0,0,.29-.12,2.46,2.46,0,0,1,2-1.08.32.32,0,0,0,.32-.3.33.33,0,0,0-.3-.32h0a3,3,0,0,0-2.46,1.34.29.29,0,0,0,0,.42h0Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "129.994995px 253.43187px",
              }}
              id="elkcnj8oa382j"
              className="animable"
            />
            <path
              d="M132.47,263.77h0a4.69,4.69,0,0,1-3.73-2.25.17.17,0,0,1,.07-.22.16.16,0,0,1,.21.06h0a4.5,4.5,0,0,0,3.47,2.07.16.16,0,0,1,.15.17h0a.16.16,0,0,1-.16.16Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "130.682114px 262.526184px",
              }}
              id="elojj04fs9lf"
              className="animable"
            />
            <path
              d="M139.11,254a.23.23,0,0,0,.18,0,.3.3,0,0,0,.14-.41h0a3.06,3.06,0,0,0-2.26-1.68.32.32,0,0,0-.34.28h0a.31.31,0,0,0,.28.33h0a2.5,2.5,0,0,1,1.77,1.36A.28.28,0,0,0,139.11,254Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "138.146423px 252.963768px",
              }}
              id="elm8ubfl29yu"
              className="animable"
            />
            <path
              d="M122.69,259.92s3.34-5.77,1.66-10.43a9.2,9.2,0,0,1,6.48.62,9.67,9.67,0,0,0-.44-2.2s5.75-.37,9.07,2.89a9.76,9.76,0,0,0-2.85-5.57,4.4,4.4,0,0,1,2.54,0s-5.23-4.21-13.44-1.81-10.77,7.38-8.89,14.7,5.84,8.92,5.84,8.92-1.64-5.57-1.28-6.82S122.69,259.92,122.69,259.92Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "127.846977px 254.860283px",
              }}
              id="elwek95woq6w8"
              className="animable"
            />
            <path
              d="M118.16,261.84a6.16,6.16,0,0,0,3.89,2.6c2.11.41,3-1.52,2.26-3.43-.66-1.68-2.55-4-4.6-3.51A2.74,2.74,0,0,0,118.16,261.84Z"
              style={{
                fill: "rgb(235, 179, 118)",
                transformOrigin: "121.079102px 260.964508px",
              }}
              id="elb4njl7a8f4s"
              className="animable"
            />
            <path
              d="M128.16,277.3l.37.14h-11.4c-.08-.14-.15-.28-.22-.43h0l3.66-3.51a12.2,12.2,0,0,0,1.1.75,33.24,33.24,0,0,0,4.08,2.1h0c.42.19.86.37,1.33.56Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "122.719997px 275.470001px",
              }}
              id="elaf6xrwcmld7"
              className="animable"
            />
            <path
              d="M136.31,276.44v1H131l.07-.16a5.66,5.66,0,0,0,.34-1,.13.13,0,0,0,0-.06h0c.05-.22.1-.45.14-.71a10.37,10.37,0,0,0,.1-1.35c0-.33,0-.69,0-1.08h0Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "133.654999px 275.26001px",
              }}
              id="el8ads12j2sz"
              className="animable"
            />
            <g id="ell39t74ccyjk">
              <path
                d="M132.08,276.25h0a4.22,4.22,0,0,1-.34,1l0,.15H131l0,0s0,0,0,0l.08-.16a5.66,5.66,0,0,0,.34-1s0,0,0-.06h0a6,6,0,0,0,.14-.71,8.74,8.74,0,0,0,.11-1.34c0-.34,0-.7,0-1.08a3.68,3.68,0,0,1,.48,1.53A5.15,5.15,0,0,1,132.08,276.25Z"
                style={{
                  opacity: "0.2",
                  isolation: "isolate",
                  transformOrigin: "131.593857px 275.225006px",
                }}
                className="animable"
              />
            </g>
          </g>
          <path
            d="M204.15,255.91H157a1.23,1.23,0,0,1-1.23-1.24h0a1.23,1.23,0,0,1,1.23-1.23h47.12a1.24,1.24,0,0,1,1.24,1.23h0A1.24,1.24,0,0,1,204.15,255.91Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "180.564995px 254.675011px",
            }}
            id="elwdxv4uk2c3k"
            className="animable"
          />
          <path
            d="M189,244.06H157.55a1.76,1.76,0,0,0,0,3.51H189a1.76,1.76,0,1,0,0-3.51Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "173.407677px 245.814995px",
            }}
            id="elc1y0773qxiq"
            className="animable"
          />
          <path
            d="M185.15,261H157a1.23,1.23,0,0,1-1.23-1.23h0a1.23,1.23,0,0,1,1.23-1.24h28.12a1.24,1.24,0,0,1,1.24,1.24h0A1.24,1.24,0,0,1,185.15,261Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "171.064987px 259.764999px",
            }}
            id="elwztaup1mru"
            className="animable"
          />
        </g>
        <g
          id="freepik--Briefcase--inject-3"
          style={{ transformOrigin: "306.614975px 393.279984px" }}
          className="animable"
        >
          <path
            d="M294.22,373.59s4.35-5.6,10.16-5.6,10.47,5.6,10.47,5.6H310.6a11,11,0,0,0-6.22-4c-3.92-.76-6.42,4-6.42,4Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "304.535004px 370.789993px",
            }}
            id="ela98x0d8myvt"
            className="animable"
          />
          <rect
            x="276.91"
            y="372.61"
            width="60.82"
            height="45.96"
            rx="4.94"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "307.32px 395.59px",
            }}
            id="elbnukghimo9"
            className="animable"
          />
          <g id="eli38zq6at92e">
            <path
              d="M337.73,377.87v35.44a5.25,5.25,0,0,1-5.26,5.25H282.18a5.25,5.25,0,0,1-5.26-5.25V377.87a5.26,5.26,0,0,1,5.26-5.26h50.29a5.26,5.26,0,0,1,5.26,5.26Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                transformOrigin: "307.324997px 395.584991px",
              }}
              className="animable"
            />
          </g>
          <g id="elz8tc4twy0xa">
            <path
              d="M333.8,377.87v35.44a5.25,5.25,0,0,1-5.26,5.25H282.18a5.25,5.25,0,0,1-5.26-5.25V377.87a5.26,5.26,0,0,1,5.26-5.26h46.36a5.26,5.26,0,0,1,5.26,5.26Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                transformOrigin: "305.359985px 395.584991px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M335,373.26a5.88,5.88,0,0,0-3.23,5.26V397.2a2.36,2.36,0,0,1-2.37,2.36H277.86a2.34,2.34,0,0,1-2.36-2.36V378.52a5.9,5.9,0,0,1,5.91-5.91h51.06A5.26,5.26,0,0,1,335,373.26Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "305.249985px 386.085022px",
            }}
            id="elaeakqk9okx4"
            className="animable"
          />
          <g id="el0jks3ky8vzel">
            <path
              d="M335,373.26a5.88,5.88,0,0,0-3.23,5.26V397.2a2.36,2.36,0,0,1-2.37,2.36H277.86a2.34,2.34,0,0,1-2.36-2.36V378.52a5.9,5.9,0,0,1,5.91-5.91h51.06A5.26,5.26,0,0,1,335,373.26Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.2",
                transformOrigin: "305.249985px 386.085022px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M299.55,398.28h3.93a0,0,0,0,1,0,0v6.07a1.85,1.85,0,0,1-1.85,1.85h-.24a1.85,1.85,0,0,1-1.85-1.85v-6.07a0,0,0,0,1,0,0Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "301.509979px 402.240005px",
            }}
            id="el79acdcn9wra"
            className="animable"
          />
          <rect
            x="298.67"
            y="398.28"
            width="5.71"
            height="5.05"
            rx="0.65"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "301.525px 400.805px",
            }}
            id="elgvi8le12tks"
            className="animable"
          />
          <rect
            x="299.55"
            y="394.32"
            width="3.93"
            height="7.92"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "301.515px 398.28px",
            }}
            id="el2ibhvw9qtqa"
            className="animable"
          />
        </g>
        <g
          id="freepik--Character--inject-3"
          style={{ transformOrigin: "387.531662px 285.013138px" }}
          className="animable"
        >
          <g
            id="freepik--group--inject-3"
            style={{ transformOrigin: "387.531662px 285.013138px" }}
            className="animable"
          >
            <path
              d="M409.53,236.75l-5.83,5.84c-.9.9-.3,6.29,0,8.09s7.51,5.09,7.95,4.79,1.79-6.54,1.79-6.54l-6-3.08,4.2-4.91Z"
              style={{
                fill: "rgb(159, 91, 83)",
                transformOrigin: "408.332352px 246.119591px",
              }}
              id="el0mtkbitytt2i"
              className="animable"
            />
            <path
              d="M408.94,194.74c3.44,1.39,16.78,27.83,16.84,32.61s-16.84,17.44-16.84,17.44l-3.72-3.56s12.31-14.49,12.7-16.34-13.46-20-13.46-20Z"
              style={{
                fill: "rgb(61, 80, 250)",
                transformOrigin: "415.120087px 219.765007px",
              }}
              id="el9fjtzhsn9c8"
              className="animable"
            />
            <g id="el199l29b7wq5">
              <path
                d="M425.78,227.35c.06,4.78-16.84,17.44-16.84,17.44l-3.72-3.56s12.31-14.49,12.7-16.34c.21-1-3.54-6.47-7.13-11.45-3.23-4.47-6.33-8.53-6.33-8.53l1.31-3,3.17-7.2C412.38,196.13,425.72,222.57,425.78,227.35Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.4",
                  isolation: "isolate",
                  transformOrigin: "415.120087px 219.750015px",
                }}
                className="animable"
              />
            </g>
            <polygon
              points="405.92 238.99 411.07 244.79 408.94 246.37 404.46 241.36 405.92 238.99"
              style={{
                fill: "rgb(61, 80, 250)",
                transformOrigin: "407.764999px 242.68px",
              }}
              id="eljqh6tqupj"
              className="animable"
            />
            <g id="elzx27p9q229j">
              <path
                d="M410.79,213.44c-3.23-4.47-6.33-8.53-6.33-8.53l1.31-3c.24-.14.48-.27.74-.4C406.51,201.54,411.13,206.76,410.79,213.44Z"
                style={{
                  opacity: "0.2",
                  isolation: "isolate",
                  transformOrigin: "407.633957px 207.475006px",
                }}
                className="animable"
              />
            </g>
            <path
              d="M380.31,172.76a18.07,18.07,0,0,1-2.67,3.4,2.33,2.33,0,0,0,2.19,1.08Z"
              style={{
                fill: "rgb(162, 78, 63)",
                transformOrigin: "378.974976px 175.005081px",
              }}
              id="elzpqxbx1g48f"
              className="animable"
            />
            <path
              d="M379.46,171.43c-.06.7.27,1.3.74,1.33s.89-.5.94-1.2-.28-1.29-.74-1.33S379.51,170.73,379.46,171.43Z"
              style={{
                fill: "rgb(46, 53, 58)",
                transformOrigin: "380.298996px 171.49456px",
              }}
              id="elz6mlf8955f8"
              className="animable"
            />
            <path
              d="M380.25,179.85a8.79,8.79,0,0,0,.32,1,10.07,10.07,0,0,0,3.58,4.78,11.85,11.85,0,0,0,1.31.81,9.11,9.11,0,0,0,7.85.34,9,9,0,0,0,3-2.07c3.63-3.67,3.54-7.9,3.95-15.07a9.84,9.84,0,0,0-13.57-9.8C379.66,162.74,378.7,173.4,380.25,179.85Z"
              style={{
                fill: "rgb(159, 91, 83)",
                transformOrigin: "389.948975px 173.301765px",
              }}
              id="elisjd3tex4zp"
              className="animable"
            />
            <g id="elvnbe7sc4g">
              <path
                d="M384.15,185.66a11.85,11.85,0,0,0,1.31.81,9.11,9.11,0,0,0,7.85.34,10.6,10.6,0,0,0-1.28-2.43A14.11,14.11,0,0,0,384.15,185.66Z"
                style={{
                  opacity: "0.2",
                  isolation: "isolate",
                  transformOrigin: "388.72998px 185.903442px",
                }}
                className="animable"
              />
            </g>
            <path
              d="M398.58,195c-3.54,3.21-12.19,2-12.19,2s-5.4-1.47-4.26-3.16c3.18-.53,4.72-2,5.36-3.91a9.44,9.44,0,0,0,.32-3.63,20.16,20.16,0,0,0-.27-2l10.69-7.92C396.83,181.55,395.12,191.16,398.58,195Z"
              style={{
                fill: "rgb(159, 91, 83)",
                transformOrigin: "390.27594px 186.801773px",
              }}
              id="el8ebfz40jbd6"
              className="animable"
            />
            <path
              d="M388.73,156.78s-1.89-1.16-5.13,1.89c-2.72,2.57,0,4.63-1.63,7.93s.58,6.55.58,6.55,1.57,3.38,4.31,3.17c0,0,2.23,2.7,1.87,5.5s3.66,5,9.13,4.94,3.28-3.49,3.28-3.49a22.68,22.68,0,0,0,3.8-6.13,21.26,21.26,0,0,0,1.55-8.57,11.46,11.46,0,0,0-3.16-8.29C399.68,156.17,391,154.1,388.73,156.78Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "393.934158px 171.168755px",
              }}
              id="el4he1jn3x4jo"
              className="animable"
            />
            <path
              d="M388.22,174.76a4.63,4.63,0,0,1-2.38,3.19c-1.46.62-2.42-1.44-2.21-3.6.2-1.91,1.19-4.6,2.75-4.24S388.73,172.83,388.22,174.76Z"
              style={{
                fill: "rgb(159, 91, 83)",
                transformOrigin: "385.987778px 174.069618px",
              }}
              id="elzm2gotis67l"
              className="animable"
            />
            <path
              d="M382.53,164.43s-5.36-5-2.92-10.41,2.92,0,2.92,0,4.05-3.22,6.2-2.4-1.36,2.67-1.36,2.67S402.64,151.56,404,161,382.53,164.43,382.53,164.43Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "391.515884px 158.900902px",
              }}
              id="el1ytsg34zaqs"
              className="animable"
            />
            <path
              d="M381.2,169.71a.35.35,0,0,1-.29-.14,1.08,1.08,0,0,0-.73-.47.36.36,0,0,1-.37-.34.36.36,0,0,1,.32-.38,1.67,1.67,0,0,1,1.35.75.36.36,0,0,1-.06.51A.34.34,0,0,1,381.2,169.71Z"
              style={{
                fill: "rgb(46, 53, 58)",
                transformOrigin: "380.684341px 169.045128px",
              }}
              id="elpiilwv3x0l"
              className="animable"
            />
            <path
              d="M399.45,194.28l-1.58-4.08s-10.66-2-14.27,3.26S399.45,194.28,399.45,194.28Z"
              style={{
                fill: "rgb(61, 80, 250)",
                transformOrigin: "391.301712px 192.928963px",
              }}
              id="el2n7gvbqmoz"
              className="animable"
            />
            <polygon
              points="371.01 411.7 363.53 412.48 363.15 408.15 362.13 396.36 369.61 395.57 370.74 408.59 371.01 411.7"
              style={{
                fill: "rgb(159, 91, 83)",
                transformOrigin: "366.570007px 404.025009px",
              }}
              id="elkow92gq49b"
              className="animable"
            />
            <polygon
              points="408.33 410.75 401.08 410.75 401.02 409.11 401.01 408.91 400.64 398.4 400.63 398.19 400.48 394.16 407.74 394.16 408.33 410.75"
              style={{
                fill: "rgb(159, 91, 83)",
                transformOrigin: "404.404999px 402.455002px",
              }}
              id="elw9hy9jbwyr"
              className="animable"
            />
            <g id="elfayu2rz4e9">
              <polygon
                points="369.61 395.57 370.74 408.59 363.15 408.15 362.13 396.36 369.61 395.57"
                style={{
                  opacity: "0.2",
                  isolation: "isolate",
                  transformOrigin: "366.434998px 402.080002px",
                }}
                className="animable"
              />
            </g>
            <g id="eltiag851hsem">
              <polygon
                points="408.28 409.83 408.27 409.83 401.02 408.91 401.01 408.91 400.63 398.76 400.64 398.76 407.91 399.35 408.27 409.51 408.28 409.83"
                style={{
                  opacity: "0.2",
                  isolation: "isolate",
                  transformOrigin: "404.455002px 404.294998px",
                }}
                className="animable"
              />
            </g>
            <path
              d="M400.08,410.31h8.8a.64.64,0,0,1,.62.5l1.43,6.46a1.07,1.07,0,0,1-.83,1.26.85.85,0,0,1-.23,0c-2.85-.05-4.92-.23-8.5-.23-2.2,0-8.85.24-11.89.24s-3.44-3-2.2-3.29c5.59-1.21,9.79-2.9,11.58-4.5A1.78,1.78,0,0,1,400.08,410.31Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "398.787338px 414.424667px",
              }}
              id="ely9lsdl0plpe"
              className="animable"
            />
            <path
              d="M362.74,410.08h8.81a.64.64,0,0,1,.61.5l1.43,6.45a1.07,1.07,0,0,1-.82,1.27l-.24,0c-2.85-.05-4.92-.23-8.5-.23-2.2,0-8.85.23-11.89.23s-3.44-3-2.2-3.28c5.59-1.21,9.8-2.9,11.58-4.51A1.83,1.83,0,0,1,362.74,410.08Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "361.448532px 414.189743px",
              }}
              id="eluywbppksish"
              className="animable"
            />
            <path
              d="M361.45,407.06h10.63s-.87-91.5,10.63-122.41c.81,10.22,1.72,20.82,2.61,29.65.57,5.47,1.12,10.16,1.64,13.74,3.35,23,11.8,79.94,11.8,79.94h10.5s-1.25-54.51-2.49-77.17c-1.38-24.58-2-78.63-2-83.24H366.29C362.63,266.93,353.24,344.37,361.45,407.06Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "383.719345px 327.774994px",
              }}
              id="eligj5yr9i4wr"
              className="animable"
            />
            <g id="elhf5txx9zt9">
              <path
                d="M382.71,284.61c.81,10.22,1.72,20.84,2.61,29.67,1.31-12.75,2.92-21.84,2.92-21.84s1.5-1.24,5.63-7.83,0-18.9,0-18.9C394,277.14,382.71,284.61,382.71,284.61Z"
                style={{
                  opacity: "0.2",
                  isolation: "isolate",
                  transformOrigin: "389.207748px 289.99501px",
                }}
                className="animable"
              />
            </g>
            <polygon
              points="360.25 404.07 360.77 407.06 373.33 407.06 373.33 404.3 360.25 404.07"
              style={{
                fill: "rgb(61, 80, 250)",
                transformOrigin: "366.789993px 405.565002px",
              }}
              id="elhjlkiyw4ks"
              className="animable"
            />
            <polygon
              points="397.55 405.22 398.76 407.99 409.29 407.99 409.98 405.22 397.55 405.22"
              style={{
                fill: "rgb(61, 80, 250)",
                transformOrigin: "403.764999px 406.604996px",
              }}
              id="elkcbv0qsyea"
              className="animable"
            />
            <path
              d="M405.7,250.13s-1.48-8.72.72-34.15c.57-6.55,1.38-13.67,2.52-21.24,0,0-20.91-4.62-35.5,0,0,0-.6,3.1-1.42,8.37-.51,3.17-1.09,7.13-1.67,11.68h0l-.06.51c-1.45,11.08-4.21,19.29-4.49,34.17Z"
              style={{
                fill: "rgb(61, 80, 250)",
                transformOrigin: "387.369995px 221.408333px",
              }}
              id="el1ej3xfzbqbl"
              className="animable"
            />
            <g id="elpnvi08kndt">
              <path
                d="M406.42,216c-2.2,25.43-.72,34.15-.72,34.15l-39.91-.65c.25-13.18,2.44-21.13,3.95-30.48.19-1.2.38-2.43.54-3.69l.06-.51h0c.48-3.77,1-7.13,1.41-10,.08-.59.17-1.16.26-1.7.82-5.27,1.42-8.37,1.42-8.37,14.59-4.62,35.5,0,35.5,0C407.8,202.31,407,209.43,406.42,216Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.4",
                  isolation: "isolate",
                  transformOrigin: "387.360031px 221.423325px",
                }}
                className="animable"
              />
            </g>
            <g id="elyaaw6l7czp">
              <path
                d="M374.15,205.27s-.36,8.84-4.41,13.73c.19-1.2.38-2.43.54-3.69l.06-.51h0c.48-3.77,1-7.13,1.41-10A12.37,12.37,0,0,1,374.15,205.27Z"
                style={{
                  opacity: "0.2",
                  isolation: "isolate",
                  transformOrigin: "371.944992px 211.900002px",
                }}
                className="animable"
              />
            </g>
            <path
              d="M366.24,188.18l2.95-3.71a10.6,10.6,0,0,1,1.23-2.37c.43-.38,5.79-3,6.15-2.84a49,49,0,0,1,2.68,5.14c.28.58-4,2.61-5.14,2.9a3.71,3.71,0,0,1-2.17-.15l-2.32,3.76"
              style={{
                fill: "rgb(159, 91, 83)",
                transformOrigin: "372.751572px 185.081482px",
              }}
              id="elfw0cszwy1ml"
              className="animable"
            />
            <path
              d="M373.57,194.78c-3,1.22-6.32,4.57-11,9.34l8.17-14.75-4.22-2.49s-16.91,23.65-16.91,26.93,4.44,5.85,21.4-3c0,0,4.51-6.45,4.51-10.24A8.49,8.49,0,0,0,373.57,194.78Z"
              style={{
                fill: "rgb(61, 80, 250)",
                transformOrigin: "362.56897px 201.870102px",
              }}
              id="elm0cg4nyazxm"
              className="animable"
            />
            <g id="elgubwcac39ja">
              <path
                d="M373.57,194.78c-3,1.22-6.32,4.57-11,9.34l8.17-14.75-4.22-2.49s-16.91,23.65-16.91,26.93,4.44,5.85,21.4-3c0,0,4.51-6.45,4.51-10.24A8.49,8.49,0,0,0,373.57,194.78Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.4",
                  isolation: "isolate",
                  transformOrigin: "362.56897px 201.870102px",
                }}
                className="animable"
              />
            </g>
            <polygon
              points="366.96 186.01 371.88 188.78 370.87 191.68 364.36 188.06 366.96 186.01"
              style={{
                fill: "rgb(61, 80, 250)",
                transformOrigin: "368.119995px 188.844994px",
              }}
              id="el8g22ttu3l0q"
              className="animable"
            />
          </g>
        </g>
        <defs>
          {" "}
          <filter id="active" height="200%">
            {" "}
            <feMorphology
              in="SourceAlpha"
              result="DILATED"
              operator="dilate"
              radius={2}
            />{" "}
            <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />{" "}
            <feComposite
              in="PINK"
              in2="DILATED"
              operator="in"
              result="OUTLINE"
            />{" "}
            <feMerge>
              {" "}
              <feMergeNode in="OUTLINE" /> <feMergeNode in="SourceGraphic" />{" "}
            </feMerge>{" "}
          </filter>{" "}
          <filter id="hover" height="200%">
            {" "}
            <feMorphology
              in="SourceAlpha"
              result="DILATED"
              operator="dilate"
              radius={2}
            />{" "}
            <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />{" "}
            <feComposite
              in="PINK"
              in2="DILATED"
              operator="in"
              result="OUTLINE"
            />{" "}
            <feMerge>
              {" "}
              <feMergeNode in="OUTLINE" /> <feMergeNode in="SourceGraphic" />{" "}
            </feMerge>{" "}
            <feColorMatrix
              type="matrix"
              values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
            />{" "}
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default SearchUsers;
